<template>
	<div class="list-stores">
		<div class="list-stores__all">
			<InputCheckbox :label="'Выбрать все'" ref="allCheckbox" v-model="selectAll"/>
		</div>
		<div class="list-stores__block">
			<div class="list-stores__list" ref="checkboxList">
				<div class="list-stores__item" v-for="item in filteredStores" :key="item">
					<InputCheckbox @change="fillSelectedStores" :label="item.name" :description="item.address" :id="item.id"/>
				</div>
			</div>
			<div v-if="filteredStores?.length < 1" class="list-stores__empty">
				Магазины не найдены
			</div>
		</div>
	</div>
</template>

<script>
import InputCheckbox from "@/components/base/utils/formElements/InputCheckbox.vue";
import {mapActions, mapGetters} from "vuex";

export default {
	name: 'ListStores',
	components: {InputCheckbox},
	props: {
		filter: {
			type: Object,
			default: () => {}
		},
		group: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			selectAll: false,
			selectedStores: new Set()
		}
	},
	async created() {
		await this.requestStores()
		this.group?.shops.forEach(item => {
			const input  = document.querySelector(`.default-checkbox__input[id='${item.id}']`)
			input.checked = true
			setTimeout(() => input.dispatchEvent(new Event('change', {bubbles: true})),100)
		})
	},
	methods: {
		fillSelectedStores(e) {
			if (e.target.checked) {
				this.selectedStores.add(e.target.id)
			} else {
				this.selectedStores.delete(e.target.id)
				if(this.selectAll) {
					this.$refs.allCheckbox.$el.querySelector('input').checked = false
				}
			}
			this.$emit('update:modelValue', Array.from(this.selectedStores))
		},
		...mapActions({
			requestStores: 'storeGroups/requestStores',
		}),
	},
	computed: {
		filteredStores() {
			if (this.filter.query) {
				return this.stores.filter(data => {
					if (data.name.toLowerCase().includes(this.filter.query.toLowerCase())) {
						return true;
					}
				});
			}
			return this.stores
		},

		...mapGetters({
			stores: 'storeGroups/getStores',
		})
	},
	watch: {
		selectAll() {
			let checkboxes = this.$refs.checkboxList.querySelectorAll('.default-checkbox__input')
			checkboxes.forEach(item => {
				item.checked = this.selectAll
				item.dispatchEvent(new Event('change', {bubbles: true}));
			})
		}
	}
}
</script>
